import { useQuery } from "@tanstack/react-query";
import { Link } from "@/lib/router-compat";
import { CouponsHubLink } from "@/components/seo/CouponsHubLink";
import { homeCouponsQueryOptions } from "@/lib/homeQueries";

export const HomeSeoLinks = () => {
  const { data = [] } = useQuery(homeCouponsQueryOptions());
  const top = [...data].sort((a, b) => (b.uses_count ?? 0) - (a.uses_count ?? 0)).slice(0, 16);

  return (
    <section className="border-t bg-muted/30 py-8" aria-labelledby="home-mais-buscados">
      <div className="container">
        <h2 id="home-mais-buscados" className="font-display text-xl font-bold mb-4">Cupons mais buscados</h2>
        {top.length > 0 && (
          <ul className="grid grid-cols-2 gap-x-6 gap-y-1 sm:grid-cols-3 lg:grid-cols-5 text-sm">
            {top.map((c) => (
              <li key={c.brand.slug} className="min-w-0 truncate">
                <Link to={`/marca/${c.brand.slug}`} className="text-foreground/80 hover:text-primary">Cupom {c.brand.name}</Link>
              </li>
            ))}
          </ul>
        )}
        <CouponsHubLink className="mt-6" />
      </div>
    </section>
  );
};
